import { Icon } from "./Icon.tsx";

export function PlayIcon() {
  return (
    <Icon>
      <path d="M6 4l14 8-14 8V4Z" />
    </Icon>
  );
}
